import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, IconButton, MenuItem, TextField, Toolbar, Typography } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import JoditEditor from "jodit-react";
import MobileDetect from 'mobile-detect';
import React, { useCallback, useRef } from "react";
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/ConteudoActions';


const md = new MobileDetect(window.navigator.userAgent);

const newConteudoState = {
    tipo: null,
    idconteudo: null,
    titulo: null,
    descricao: null,
    conteudo: null,
    grupo: null,
    categoria: null,
    statusregistro: null,
};


class ConteudoDialog extends XAPPComponent {


    state = {
        ...newConteudoState,
        tipo: this.props.tipo
    };

    componentDidUpdate(prevProps, prevState) {

        if (this.props.Conteudo.error) {
            this.props.showMessage({
                message: this.props.Conteudo.error,
                variant: 'error'
            });
            this.props.Conteudo.error = null;
        }
        if (this.props.Conteudo.warning) {
            this.props.showMessage({
                message: this.props.Conteudo.warning,
                variant: 'warning'
            });
            this.props.Conteudo.warning = null;
        }
        if (this.props.Conteudo.info) {
            this.props.showMessage({
                message: this.props.Conteudo.info,
                variant: 'success'
            });
            this.props.Conteudo.info = null;
            this.props.openDialog();
        }

        if (!_.isNull(this.props.open) && !_.isEqual(prevProps.open, this.props.open)) {
            this.setState(Object.assign({}, this.props.open));
        }

        if (_.isNull(this.props.open) && !_.isEqual(prevProps.open, this.props.open)) {
            this.setState(Object.assign({}, newConteudoState, { tipo: this.props.tipo }));
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    };

    canBeSubmitted = () => {
        const form = this.state;

        return (
            form.titulo !== null && form.titulo !== "" &&
            form.conteudo !== null && form.conteudo !== "" &&
            form.tipo !== null && form.tipo !== "" &&
            (form.tipo === 1 && (form.grupo !== null && form.grupo !== "" && form.categoria !== null && form.categoria !== "") || form.tipo !== 1)
        );
    }

    onBlur = (e) => {
        this.handleChange({ target: { type: "jodit", name: "conteudo", value: e.currentTarget.innerText } });

    }


    render() {
        const { save, xappRouteParams, Conteudo, openDialog, open = null, theme, TIPOS, GRUPOS, tipo } = this.props;
        const form = this.state;


        return (
            <XAPPDialog
                id="Conteudo"
                open={!_.isNull(open)}
                onClose={() => openDialog()}
                fullWidth
                fullScreen
            >

                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {_.isNull(form.idconteudo) ? "Novo conteudo" : "Editar conteudo"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog()}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent className="p-20">
                    <TextField
                        className="mb-12 w-full"
                        label="Titulo"
                        id="titulo"
                        name="titulo"
                        value={form.titulo}
                        onChange={this.handleChange}
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="mb-12 w-full"
                        label="Descrição"
                        id="descricao"
                        name="descricao"
                        value={form.descricao}
                        onChange={this.handleChange}
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    {_.isNull(tipo) &&
                        <TextField
                            className="mb-12 w-full"
                            label="Tipo"
                            id="tipo"
                            name="tipo"
                            value={form.tipo}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            select
                            disabled={!_.isNull(form.idconteudo)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        >
                            {TIPOS.map(item => (
                                <MenuItem key={"Tipo_" + item.id} value={item.id}>{item.label}</MenuItem>
                            ))}
                        </TextField>
                    }
                    {form.tipo === 1 &&
                        <TextField
                            className="mb-12 w-full"
                            label="Grupo"
                            id="grupo"
                            name="grupo"
                            value={form.grupo}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            select
                            InputLabelProps={{
                                shrink: true,
                            }}
                        >
                            {GRUPOS.map(item => (
                                <MenuItem key={"Grupo_" + item.id} value={item.id}>{item.label}</MenuItem>
                            ))}
                        </TextField>
                    }
                    {form.tipo === 1 && !_.isNull(form.grupo) &&
                        <TextField
                            className="mb-12 w-full"
                            label="Categoria"
                            id="categoria"
                            name="categoria"
                            value={form.categoria}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            select
                            InputLabelProps={{
                                shrink: true,
                            }}
                        >
                            {_.find(GRUPOS, { id: form.grupo }).categorias.map(item => (
                                <MenuItem key={"Categoria_" + item.id} value={item.id}>{item.label}</MenuItem>
                            ))}
                        </TextField>
                    }
                    <div className="flex">
                        <JoditEditor
                            className="h-640"
                            value={form.conteudo}
                            config={{
                                //readOnly: readOnly,
                                iframe: true,
                                language: "pt_br",
                                allowResizeX: false,
                                allowResizeY: true,
                                width: '100%',
                                theme: theme.palette.type === "dark" && "dark",
                                autofocus: false,
                                showCharsCounter: false,
                                showWordsCounter: false,
                                showXPathInStatusbar: false,
                                defaultActionOnPaste: "insert_only_text",
                                uploader: {
                                    insertImageAsBase64URI: true
                                }
                            }}
                            onBlur={this.onBlur}
                        />
                    </div>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0 px-8">
                        <DialogActions>
                            {!_.isNull(form.idconteudo) &&
                                <XAPPButton
                                    type="Button"
                                    className="bg-grey-darker hover:bg-grey-darker text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => save(form, xappRouteParams, 'INATIVARCONTEUDO')}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"block"}
                                    label={md.mobile() === null && md.tablet() === null ? (form.statusregistro === 0 ? 'Ativar' : 'Inativar') : ''}
                                />
                            }
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white mr-8"
                                variant="contained"
                                color="primary"
                                onClick={() => save(form, xappRouteParams, _.isNull(form.idconteudo) ? 'INSERIRCONTEUDO' : 'ATUALIZARCONTEUDO')}
                                disabled={!this.canBeSubmitted()}
                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                icon={"save"}
                                label={md.mobile() === null && md.tablet() === null ? 'Salvar' : ''}
                            />
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        save: Actions.save,
        showMessage: AppActions.showMessage,
        openDialog: Actions.openDialog
    }, dispatch);
}

function mapStateToProps({ Conteudo, fuse }) {
    return {
        Conteudo: Conteudo,
        open: Conteudo.dialog,
        theme: fuse.settings.mainTheme
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConteudoDialog);
